<template>
  <div class="shtar-animation__container">
    <p class="shtar-animation__title">SHTAR SYSTEM</p>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Observer } from "gsap/Observer";
gsap.registerPlugin(ScrollTrigger);

export default {
  data() {
    return {
      tl: null,
    };
  },
  mounted() {

    this.tl = gsap.timeline();

    this.tl.to(".shtar-animation__title", {
      scrollTrigger: {
        trigger: ".shtar-animation__container",
        start: "0% 80%",
        end: "10% 40%",
        scrub: 0,
        ease: "none",
        // markers: true,
      },
      backgroundSize: "100%",
    });

  },
  beforeUnmount() {
    this.tl.kill();
    this.tl = null;
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/grid/grid";

.shtar-animation__title {
  --fill-color: #fff;
  position: relative;
  display: block;
  background: linear-gradient(var(--fill-color) 0 100%) left / 0 no-repeat;
  color: #ffffff48;
  background-clip: text;

  @include myAdaptivPadding(0, 0, 150, 0, 150, 0, 50, 0);

  text-align: center;
  font-family: Orbitron, sans-serif;
  font-size: 5vw;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;

  transition: 1s ease-in-out;
}
</style>
